import { parseTimezoneToHour } from './timezone'

const MILLISECONDS_PER_HOUR = 60 * 60 * 1000

type AccountingPeriod = {
  id: number
  start: number
  end: number
}

/**
 * Portfolio の timezone を考慮しつつ、会計期間リストを昇順で生成する。
 */
export const createAccountingPeriods = (params: {
  oldestTimestamp: number
  startMonth: number
  timezone: string
}): readonly AccountingPeriod[] => {
  const { oldestTimestamp, startMonth: startMonthStartsOne, timezone } = params

  const timezoneHour = parseTimezoneToHour(timezone)
  const timezoneOffsetMs = timezoneHour * MILLISECONDS_PER_HOUR
  const startMonth = startMonthStartsOne - 1
  const startDate = createStartDate(
    oldestTimestamp,
    startMonth,
    timezoneOffsetMs,
  )
  const accountingPeriods: AccountingPeriod[] = []

  const nowLocal = Date.now() + timezoneOffsetMs
  let currentLocalStart = startDate.getTime() + timezoneOffsetMs
  while (currentLocalStart < nowLocal) {
    const periodYear = new Date(currentLocalStart).getUTCFullYear()
    const nextLocalStart = Date.UTC(periodYear + 1, startMonth, 1)

    accountingPeriods.push({
      id: periodYear,
      start: currentLocalStart - timezoneOffsetMs,
      end: nextLocalStart - timezoneOffsetMs - 1,
    })

    currentLocalStart = nextLocalStart
  }

  return accountingPeriods
}

/**
 * 与えられた timestamp が属する会計年度の開始日時 (UTC) を返す。
 */
const createStartDate = (
  timestamp: number,
  startMonth: number,
  timezoneOffsetMs: number,
): Date => {
  const localizedTimestamp = timestamp + timezoneOffsetMs
  const localizedYear = new Date(localizedTimestamp).getUTCFullYear()
  const startOfYearLocal = Date.UTC(localizedYear, startMonth, 1)
  const nextStartOfYearLocal = Date.UTC(localizedYear + 1, startMonth, 1)

  if (localizedTimestamp < startOfYearLocal) {
    const previousStartLocal = Date.UTC(localizedYear - 1, startMonth, 1)
    return new Date(previousStartLocal - timezoneOffsetMs)
  }
  if (localizedTimestamp >= nextStartOfYearLocal) {
    return new Date(nextStartOfYearLocal - timezoneOffsetMs)
  }
  return new Date(startOfYearLocal - timezoneOffsetMs)
}
